<div class="row row-header">
  <div class="col-md-11 col-sm-11">
    <h1 mat-dialog-title class="text-center ml115">New Run Request</h1>
  </div>
  <div class="col-md-1 col-sm-1 nopadding">
    <a class="cancelBtn cancelBtnPos" (click)="onCancelClick()"></a>
  </div>
</div>
<div class="run-box">
  <form #runForm="ngForm">

    <div mat-dialog-content>
      <div class="row px-5 pt-2 no-overflow">
        <div class="col-sm-6 division pad-lr">
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Start Date</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input placeholder="Start Date Time"
                     class="form-control wd85"
                     required name="startDate"
                     [(ngModel)]="startDate"
                     [owlDateTime]="dt"
                     [readonly]="true">
              <span class="pointer trigger date_icon" [owlDateTimeTrigger]="dt">
                <mat-icon>date_range</mat-icon>
              </span>
              <owl-date-time #dt></owl-date-time>
              <div class="text-danger" *ngIf="datDiffErrMsg != ''">
                <p class="ml-15">{{datDiffErrMsg}}</p>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Target</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <select name="target" ngModel #target="ngModel" class="form-control" (change)="chkTillADL($event)" required>
                <option value="Use Case Database" selected="selected">Use Case Database</option>
                <option value="Azure Datalake">Azure Datalake</option>
              </select>
              <div class="text-danger" *ngIf="target.invalid && target.touched">
                Please provide valid target
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Use Case</label>
              <span class="text-danger star-danger" *ngIf="checkedADL == false">*</span>
            </div>
            <div class="col-sm-8 customDropDown2">
              <input type="text" class="form-control "
                     name="useCase" ngModel #useCase="ngModel"
                     [typeahead]="useCaseList"
                     [typeaheadOptionField]="'useCaseName'"
                     (typeaheadOnSelect)="useCaseKeyUp(useCase)"
                     placeholder="Select Use Case"
                     (focusout)="useCaseKeyUp(useCase)"
                     autocomplete="off">
              <div class="text-danger" *ngIf="useCaseFlag == true">
                Please provide a valid Use Case
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 pad-lr">
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">End Date</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8">
              <input placeholder="End Date Time"
                     class="form-control wd85"
                     required name="endDate"
                     [(ngModel)]="endDate"
                     (ngModelChange)="onDate($event)"
                     [owlDateTime]="dt1"
                     [readonly]="true">
              <span class="pointer trigger date_icon" [owlDateTimeTrigger]="dt1">
                <mat-icon>date_range</mat-icon>
              </span>
              <owl-date-time #dt1></owl-date-time>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Location</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8 customDropDown1">
              <input type="text" class="form-control"
                     id="locations"
                     name="locations"
                     #locations="ngModel"
                     [(ngModel)]="selectedLocationName"
                     [typeahead]="locationList"
                     [typeaheadOptionField]="'locationName'"
                     (typeaheadOnSelect)="onSelectLocation()"
                     placeholder="Select Location"
                     [typeaheadOptionsLimit]="5"
                     autocomplete="off"
                     required>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Unit</label>
              <span class="text-danger star-danger">*</span>
            </div>
            <div class="col-sm-8 customDropDown1">
              <input type="text" class="form-control"
                     name="unit" ngModel #unit="ngModel"
                     [typeahead]="unitList"
                     [typeaheadOptionField]="'unitName'"
                     (typeaheadOnSelect)="unitKeyUp(unit)"
                     placeholder="Select Unit"
                     (focusout)="unitKeyUp(unit)"
                     autocomplete="off"
                     required>
              <div class="text-danger" *ngIf="unitFlag == true">
                Please provide a valid unit
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-4">
              <label class="form-label" for="">Tags</label>
              <span class="text-danger star-danger">*</span>
              <span matTooltip="Tag ids selection limit is 100." matTooltipPosition="right" matTooltipclass="tooltip"><mat-icon class="help-icon">help_outline</mat-icon></span>
            </div>
            <div class="col-sm-8">
              <button class="saveBtn2 mr5" tabindex="0" (click)="getTagList()">Load Tags</button>
              <span class="text-center" *ngIf="isLoader==true">
                <span class="loader"></span>
              </span>
              <div>
                <p class="pbc" *ngIf="tagsFlag == false">You have selected {{tagCounter}} tags.</p>
                <p class="text-danger" *ngIf="tagsFlag == true">No tags found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="tagList.length > 0">
      <div class="col-md-12 col-lg-12">
        <div class="row pl-20 white">
          <mat-checkbox #checkbox [checked]="tagList.length == tagCounter" name="tagIds" value="" (change)="checkUncheckAll()">Select / Unselect All {{chkUnchk}}</mat-checkbox>
        </div>
        <div class="row box-content">
          <div class="col-md-3 col-lg-3" *ngFor="let tag of tagList">
            <ng-container>
              <mat-checkbox #checkbox [checked]="allChecked" name="tagIds" ngModel #tagIds="ngModel" value="tag.tagId" (change)="chkTagIds(tag.tagId)" [required]="this.selectedTagIds > 0">{{tag.tagId}}</mat-checkbox>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="col-sm-12 btnRow-align text-center">
        <button class="saveBtn2 mr5" [disabled]="!runForm.valid || !lenErr || useCaseFlag" (click)="saveRun(runForm)">RUN</button>
        <p *ngIf="error">Something went wrong. Try again!</p>
        <button class="saveBtn2" tabindex="0" (click)="resetRun()">CLEAR</button>
      </div>
    </div>
    <div></div>
  </form>
</div>
